import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBCQIKbcpAm_pGX5gwd_6f2XMHXfg3yJfg",
  authDomain: "testpushnotifications-fb862.firebaseapp.com",
  projectId: "testpushnotifications-fb862",
  storageBucket: "testpushnotifications-fb862.appspot.com", // ← corrected `firebasestorage.app`
  messagingSenderId: "150510681156",
  appId: "1:150510681156:web:b0d259fd8b9325aa8d9011",
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

// 🔔 Ask permission and return FCM token
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: "BKRk7dfghTwlJXYQb6TbwbJ-spTkEblbYGCsIj5A5klSMvTaGVm9QyGJ0XjihdbGmZ42FqqDqKr-dD8Eo9LstYY",
      });
      console.log("✅ FCM Token:", token);
      return token;
    } else {
      console.warn("❌ Notification permission not granted");
      return null;
    }
  } catch (error) {
    console.error("🚫 Error getting FCM token:", error);
    return null;
  }
};

// 📬 Listen for foreground messages
export const listenForMessages = (callback) => {
  onMessage(messaging, (payload) => {
    console.log("📩 Foreground message received:", payload);
    callback(payload);
  });
};

export { messaging };
